import { apiPost } from './http'

export const remove = async request =>
  apiPost('/notifications/admin/delete', request, { auth: true })
